import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../utils/analytics';

const WelcomeBonus = () => {
  return (
    <motion.div
      className="mt-8 mb-8"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 dark:from-blue-700 dark:to-blue-800 rounded-xl p-6 shadow-lg text-white">
        <div className="flex flex-col sm:flex-row items-center gap-4">
          {/* Логотип */}
          <div className="flex-shrink-0">
            <img 
              src="/logos/1xbet.png" 
              alt="1xBet" 
              className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-contain bg-white p-2 shadow-md"
              width="64"
              height="64"
            />
          </div>
          
          {/* Контент */}
          <div className="flex-grow text-center sm:text-left">
            <h3 className="text-xl sm:text-2xl font-bold mb-2">
              Welcome Bonus
            </h3>
            <p className="text-lg sm:text-xl mb-1 text-blue-100">
              130% welcome bonus on first deposit
            </p>
            <p className="text-2xl sm:text-3xl font-bold text-yellow-300">
              Up to €130
            </p>
          </div>
          
          {/* Кнопка */}
          <div className="flex-shrink-0 w-full sm:w-auto">
            <a
              href="/1xmobi"
              target="_blank"
              rel="nofollow noreferrer"
              onClick={() => trackEvent('Click-welcome-bonus')}
              className="block w-full sm:w-auto bg-yellow-500 hover:bg-yellow-400 text-gray-900 px-8 py-3 rounded-lg font-bold text-lg text-center transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              Claim Now
            </a>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default WelcomeBonus; 